import { render, staticRenderFns } from "./TrancheList.vue?vue&type=template&id=3a1f7b0a&"
import script from "./TrancheList.vue?vue&type=script&lang=js&"
export * from "./TrancheList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports